export default "__VITE_ASSET__DvHRH4rL__"